<template>
  <div class="section-parameter">
    <div class="col-left">
      <h2>Badges</h2>
    </div>
    <div class="col-right" v-if="badges.length > 0">
      <div class="list" v-for="badge in badges" :key="badge.id">
        <badge :id="badge.id"></badge>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import badge from '@/components/settings/translations/translations_badge'

export default {
  components: { badge },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    ...mapGetters('badges', {
      badges: 'badges'
    })
  },
  methods: {
    ...mapActions('badges', ['loadBadges']),

    init () {
      if (this.site) {
        this.loadBadges()
      }
    }
  },

  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.list {
  border-bottom: 1px dashed #aaa;
  padding:12px 0;
  margin:12px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_badges.vue